<div class="notice warn" *ngIf="!available">
  The copilot needs the Claude key, which is not set here. You can read old sessions; new messages will fail.
</div>
<div class="copilot">
  <aside class="sessions">
    <button mat-stroked-button class="new" (click)="newSession()" [disabled]="working">New session</button>
    <button type="button" class="session" *ngFor="let s of sessions" [class.on]="view?.session?.id === s.id"
      (click)="open(s.id)" [disabled]="working">
      <span class="title">{{ s.title || 'Untitled' }}</span>
      <span class="muted">{{ s.updatedAt | date: 'd MMM, HH:mm' }}</span>
    </button>
    <p class="muted" *ngIf="!sessions.length && !loading">No sessions yet.</p>
  </aside>

  <section class="stream">
    <div class="loading" *ngIf="loading"><mat-spinner diameter="24"></mat-spinner></div>
    <p class="empty" *ngIf="!loading && !view?.items?.length">
      Ask who Sharon should talk to next, what a piece of intel means, or why she wrote something.
      Anything it wants to change comes back as a proposal you approve or reject.
    </p>
    <ng-container *ngFor="let item of view?.items ?? []">
      <div class="item" [attr.data-kind]="item.kind" [ngSwitch]="item.kind">
        <div *ngSwitchCase="'tool'" class="tool muted">⚙ {{ toolLine(item) }}</div>
        <ng-container *ngSwitchCase="'proposal'">
          <app-proposal-card *ngIf="proposal(proposalIdOf(item)) as p" [proposal]="p"
            (changed)="onProposalChanged($event)"></app-proposal-card>
        </ng-container>
        <div *ngSwitchDefault class="bubble text">{{ textOf(item) }}</div>
      </div>
    </ng-container>
    <app-proposal-card *ngFor="let p of loose" [proposal]="p" (changed)="onProposalChanged($event)"></app-proposal-card>

    <div class="notice bad" *ngIf="error">{{ error }}</div>
    <div class="composer">
      <textarea class="input" rows="3" [(ngModel)]="text" [disabled]="working" aria-label="Message to the copilot"
        placeholder="Ask the copilot…" (keydown.meta.enter)="send()" (keydown.control.enter)="send()"></textarea>
      <div class="row">
        <button mat-flat-button color="primary" (click)="send()" [disabled]="working || !text.trim()">
          {{ working ? 'Working…' : 'Send' }}
        </button>
        <span class="muted" *ngIf="working">The copilot is looking things up. This can take up to two minutes.</span>
      </div>
    </div>
  </section>
</div>
